














import { defineComponent, PropType } from "@vue/composition-api";
import { UserWithAvatar, UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";
export default defineComponent({
  name: "UserChip",
  components: { BaseIcon, BaseAvatar },
  props: {
    user: { type: Object as PropType<UserPublicData | UserWithAvatar>, required: true },
  },
});
